import StateType from './state.type';

export default {
  loading: false,
  billings: [],
  total: 0,
} as StateType;
